import React from "react";

/**
 * Shared content wrapper for sidebar pages so all load with the same
 * horizontal alignment and padding (closer to sidebar, consistent spacing).
 * Layout-only; no business logic.
 */
const PAGE_CONTENT_CLASS =
  "w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 pt-16 lg:pt-6 pb-6 md:pb-8 lg:pb-10 min-w-0";

/** Main column next to the sidebar (shared across authenticated pages). */
export const PAGE_MAIN_CLASS =
  "lg:ml-60 min-h-screen min-w-0 app-shell-bg";

export const PageContent = ({ children, className = "", style }) => (
  <div className={`${PAGE_CONTENT_CLASS} ${className}`.trim()} style={style}>
    {children}
  </div>
);

export default PageContent;
export { PAGE_CONTENT_CLASS };
